import { FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_CAPTURE } from 'constants';
import useCameraMaskToCapturePhoto from 'features/uploadDocuments/hooks/useCameraMaskToCapturePhoto';
import { Fade } from 'helpers/animation';
import { useCameraCheck } from 'hooks';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { cursorPointerMixin } from 'styles';
import FormInputUploadDocumentsFileSelectTakePhotoMask from './FormInputUploadDocumentsFileSelectTakePhotoMask';
import FormInputUploadDocumentsFileSelectedMask from './FormInputUploadDocumentsFileSelectedMask';
import FormInputUploadDocumentsFileTakePhotoMask from './FormInputUploadDocumentsFileTakePhotoMask';
import FormInputUploadDocumentsFileUploadedMask from './FormInputUploadDocumentsFileUploadedMask';

const FormInputUploadDocumentsFileTakePhotoValidation = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
  fileTakePhotoType = FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_CAPTURE, // FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_SELECT_FILE
}) => {
  const { t } = useLang();

  const {
    handleShowCustomCameraMaskToCapturePhotoModal,
    handleShowCheckCameraToTakePhotoEnableAlertModal,
  } = useCameraMaskToCapturePhoto();
  const { checkAllowTakePhoto } = useCameraCheck();

  const isFileTakePhotoTypeCapture =
    fileTakePhotoType ===
    FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_CAPTURE;

  const handleOnClick = () => {
    if (!isFileTakePhotoTypeCapture) return;
    console.log(
      `⭐ FormInputUploadDocumentsFileTakePhotoValidation 👉 handleOnClick ➡️ CLICKED ↩`
    );
    if (!checkAllowTakePhoto) {
      handleShowCheckCameraToTakePhotoEnableAlertModal();
      return;
    }
    handleShowCustomCameraMaskToCapturePhotoModal({
      field,
      information,
      setInformation,
    });
  };

  const renderFormInputTypeCapture = () => {
    if (!isEmpty(information[field.name]))
      return (
        <FormInputUploadDocumentsFileUploadedMask
          name={field.name}
          imgSrc={information[field.name]}
        />
      );
    return (
      <FormInputUploadDocumentsFileTakePhotoMask
        name={field.name}
        label={t(field.label)}
      />
    );
  };
  const renderFormInputTypeSelectFile = () => {
    return (
      <>
        {!isEmpty(information[field.name]) && (
          <FormInputUploadDocumentsFileSelectedMask
            name={field.name}
            imgSrc={information[field.name]?.path}
          />
        )}
        <FormInputUploadDocumentsFileSelectTakePhotoMask
          field={field}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
      </>
    );
  };
  const renderFormInputDescription = () => {
    if (isFileTakePhotoTypeCapture) return <>{renderFormInputTypeCapture()}</>;
    return <>{renderFormInputTypeSelectFile()}</>;
  };

  const getFormInputUploadDocumentsFileTakePhotoValidationStyled = () => {
    if (validation[field.name])
      return {
        outline: '1px dashed var(--ds-c-red)',
      };
    if (information[field.name])
      return {
        outline: '1px dashed transparent',
      };
    return {
      outline: '1px dashed #7A8189',
    };
  };

  return (
    <FormInputUploadDocumentsFileTakePhotoValidationStyled
      $isError={validation[field.name]}
      onClick={handleOnClick}
      style={getFormInputUploadDocumentsFileTakePhotoValidationStyled()}
    >
      {renderFormInputDescription()}
    </FormInputUploadDocumentsFileTakePhotoValidationStyled>
  );
};

const FormInputUploadDocumentsFileTakePhotoValidationStyled = styled.div`
  position: relative;
  border-radius: 10px;
  width: 50%;
  height: 120px;
  display: flex;
  justify-content: center;
  ${Fade};
  ${cursorPointerMixin};
`;

export default FormInputUploadDocumentsFileTakePhotoValidation;
